import { useUser } from "contexts/user";
import { useFlagsmith } from "flagsmith-react";

export default function useFeatureFlag() {
  const {
    hasFeature,
    getValue,
    isLoading: isFeatureFlagLoading,
  } = useFlagsmith();
  const { user } = useUser();

  const isFeatureVisible = (id: string): boolean => {
    const valuesList = String(getValue(id)).split(",");
    const isCurrentUserEmail = Boolean(
      valuesList.find((item) => item.trim() === user?.email) ?? false
    );
    return hasFeature(id) || isCurrentUserEmail;
  };

  const isFeatureVisibleForValue = (
    id: string,
    value: string | undefined
  ): boolean => {
    if (!value) return false;
    const valuesList = String(getValue(id)).split(",");
    const valueExists = Boolean(
      valuesList.find((item) => item.trim() === value) ?? false
    );
    return hasFeature(id) && valueExists;
  };

  return {
    isFeatureVisible,
    isFeatureVisibleForValue,
    isFeatureFlagLoading,
  };
}
